import { useEffect } from "react";
import { logError } from "../../utils/appUtils";

export const ForceTitle = ({ title }) => {
  useEffect(() => {
    try {
      const titleElm = document.getElementById("react-admin-title");
      const nodes = titleElm.childNodes;
      if (nodes.length === 0) {
        const titleSpan = document.createElement("span");
        titleSpan.innerText = title;
        titleElm.appendChild(titleSpan);
      } else if (nodes.length === 2) {
        titleElm.firstChild.innerText = "";
      }
    } catch (err) {
      logError("commong:ForceTitle", err, false);
    }
  });

  return title;
};
